const ZENDESK_SSO_PREFIX = "/zendesk/sso?return_to=";

export const zendeskUrl = (path: string) =>
  `${ZENDESK_SSO_PREFIX}${encodeURIComponent(`https://support.manifold.ai/hc/en-us/articles/${path}`)}`;
